document.addEventListener('DOMContentLoaded', function() {
  const productSlider = document.querySelector('.product-slider');
  
  if (productSlider) {
    const swiper = new Swiper('.product-slider', {
      slidesPerView: 3.5,
      spaceBetween: 14,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      freeMode: true,
      grabCursor: true,
      threshold: 5,
      navigation: {
        nextEl: '.product-slider-nav-btn-next-mob',
        prevEl: '.product-slider-nav-btn-prev-mob',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        520: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        960: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          navigation: {
            nextEl: '.product-slider-nav-btn-next',
            prevEl: '.product-slider-nav-btn-prev',
          }
        },
        1070: {
          slidesPerView: 3,
          spaceBetween: 14,
          navigation: {
            nextEl: '.product-slider-nav-btn-next',
            prevEl: '.product-slider-nav-btn-prev',
          }
        },
        1280: {
          slidesPerView: 3.5,
          spaceBetween: 14,
          navigation: {
            nextEl: '.product-slider-nav-btn-next',
            prevEl: '.product-slider-nav-btn-prev',
          }
        },
      },
    });
  }
});